import feedback_component from '#BASE/components/feedBack/feedBack.component';

export default {
    mixins:[feedback_component],
    props: {
        dialog: Object
    },
    methods : {
        FeedBackSuccess() {
            this.$dialog.warning(this.resultMsg.Success);
            this.closeFeedback();
        },
        FeedBackError() {
            this.$dialog.warning(this.resultMsg.Fail);
            this.closeFeedback();
        },
        showFeedback(){
            this.feedbackContent = "";
            let _dialog = this.$dialog.get('feedback');
            _dialog.show();
        },
        closeFeedback(){
            let _dialog = this.$dialog.get('feedback');
            _dialog.hide();
        }
    }
}